import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserProgress } from '../../views/Activity/store/ActivitySelectors'
import { YumUserProgress, IUserProgressProps } from './YumUserProgress'
import { ActivityProgress, CustomType, GoalId, ProgressType, UserId } from '../../services/api.types'
import { getProgress } from '../../views/Progress/store/ProgressActions'
import { getProgressResultsSelector } from '../../views/Progress/store/progressSelectors'

export interface IOwnProps {
  goalId?: GoalId
  progressType: ProgressType
  activityFormulaTarget: number | null
  collectiveGoal: number | null
  collectiveTotal: number
  collectivePercentage: number
  ownerUserId: UserId
  participantsCount: number
  dailyPersistenceGoal: number
  startDate: number
  endDate: number
  customType: CustomType | null
  className?: string
  activityProgress?: ActivityProgress
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IUserProgressProps => {
  const {
    goalId,
    progressType,
    activityFormulaTarget,
    collectiveGoal,
    collectiveTotal,
    collectivePercentage,
    ownerUserId,
    participantsCount,
    dailyPersistenceGoal,
    startDate,
    endDate,
    activityProgress,
    customType,
    className,
  } = ownProps
  return {
    activityProgress: goalId ? getUserProgress(state, goalId) : activityProgress,
    progressType,
    activityFormulaTarget,
    collectiveGoal,
    collectiveTotal,
    collectivePercentage,
    ownerUserId,
    participantsCount,
    dailyPersistenceGoal,
    startDate,
    endDate,
    progressResults: getProgressResultsSelector(state),
    className,
    customType,
  }
}

const mapDispatchToProps = {
  getProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumUserProgress)
